import {
  DropOffTypeKey,
  DropOffsPointType,
  DropOffType,
  LabelOptionsRewriteModel,
  LabelOptionsModel,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'

export const shouldShowPickupDateOld = (
  isHomePickupSelected: boolean,
  labelOptions?: LabelOptionsModel,
): boolean => {
  if (!labelOptions) return false
  const isOldDropOffFlow = labelOptions.dropOffTypes?.some(
    ({ pickUpDateShown }: { pickUpDateShown: boolean }) => pickUpDateShown,
  )
  const isOldDropOffsFlow =
    labelOptions.dropOffs &&
    labelOptions.dropOffs.length === 1 &&
    labelOptions.dropOffs[0]?.type === DropOffsPointType.Home

  return isOldDropOffFlow || isOldDropOffsFlow || isHomePickupSelected
}

export const shouldShowNewFlow = (
  isHomePickupSelected: boolean,
  labelOptionsRewrite?: LabelOptionsRewriteModel,
): { newFlow: boolean; newFlowDetails: boolean } => {
  if (!labelOptionsRewrite) return { newFlow: false, newFlowDetails: false }

  const newDropOffs = labelOptionsRewrite.dropOffs

  const isNewDropOffFlow =
    Array.isArray(newDropOffs) &&
    newDropOffs.some(dropOff => {
      const options = dropOff?.options ?? []

      const hasPickupRequirements = options.some(
        option => option?.requiresPickupTime || option?.requiresPickupDate,
      )

      const optionTypes = new Set(options.map(option => option?.type))

      const hasHomeAndMailbox =
        optionTypes.has(DropOffType.Home) && optionTypes.has(DropOffType.Mailbox)

      const singleHomeOption =
        Array.isArray(newDropOffs[0]?.options) &&
        newDropOffs[0].options.length === 1 &&
        newDropOffs[0].options[0]?.type === DropOffType.Home

      return (hasPickupRequirements && hasHomeAndMailbox) || singleHomeOption
    })

  const isNewDropOffsFlow =
    newDropOffs &&
    newDropOffs.length > 1 &&
    newDropOffs.some(dropOff => dropOff.type === DropOffType.Home) &&
    newDropOffs.some(dropOff => dropOff.type === DropOffType.Point)

  return {
    newFlow: isNewDropOffFlow && !isHomePickupSelected,
    newFlowDetails: isNewDropOffsFlow && isHomePickupSelected,
  }
}

export const getIsContactlessDropoffFlow = (
  labelOptionsRewrite?: LabelOptionsRewriteModel,
  labelOptions?: LabelOptionsModel,
) => {
  const isContactlessInRewrite = labelOptionsRewrite?.dropOffs?.some((dropOff: any) =>
    dropOff.options?.some((option: any) => option.contactless === true),
  )

  const isContactlessInOld = labelOptions?.dropOffTypes?.some(
    (type: any) => type.key === DropOffTypeKey.ContactlessDropoff,
  )

  return isContactlessInRewrite || isContactlessInOld
}
